import { styled } from "styled-components";
import { devices } from "../../src/Constants";

export const DashboardLayout = styled.div`
	display: flex;
	overflow: hidden;

	.main {
		min-width: 100vw;
		display: flex;
		flex-direction: column;
		margin-left: 0;

		@media only screen and (${devices.lg}) {
			min-width: 80vw;
			display: flex;
			flex-direction: column;
			margin-left: 20%;
		}
	}
`;

export const SidebarWrapper = styled.div`
	display: block;
	padding-bottom: 20px;
	background-color: #003a50;
	height: 100vh;
	color: white;
	width: 20%;
	overflow: auto;
	position: fixed;
	box-shadow: 4px 0px 4px rgba(5, 55, 78, 0.05);

	& > section {
		display: flex;
		flex-direction: column;
		gap: 1.125rem;
		width: 100%;

		div {
			display: flex;
			gap: 16px;
			align-items: center;
			color: #999999;
			padding: 0.75rem 1rem 0.75rem 1.65rem;
		}

		a {
			p {
				width: 100%;
				font-weight: 500;
			}
			&.active p {
				color: #003a50;
			}
		}

		.icon {
			width: 20px;
			height: 20px;
		}
	}

	& > header {
		background: linear-gradient(180deg, #476569 -291.25%, rgba(254, 254, 254, 0) 100%);
		padding: 12px 10px 30px 28px;
	}

	@media only screen and (${devices._lg}) {
		display: none;
	}

	/* 
		Scrollbar Styling
	*/
	& {
		&::-webkit-scrollbar {
			width: 7px;
		}
		&::-webkit-scrollbar-track {
			/* background: #f1f1f1; */
			background-color: rgba(0, 57, 80, 0.5);
			box-shadow: inset 0 0 6px #888;
		}
		/* Handle */
		&::-webkit-scrollbar-thumb {
			background: #becdd2;
		}
		/* Handle on hover */
		&::-webkit-scrollbar-thumb:hover {
			background: #555;
		}
	}
`;

export const SearchButton = styled.button`
	background-color: #003a50;
	padding: 5px 22px;
	border-radius: 30px;
	color: #ffffff;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1.2rem;
	font-size: 15px;

	img {
		width: 16px;
	}

	@media (${devices._sm}) {
		p {
			display: none;
		}
	}
`;

export const LogOutButon = styled(SearchButton)`
	padding: 12px 30px;
	border-radius: 26px;
	color: #ff7878;
	font-weight: 500;
	background-color: #e6e6e6;
	gap: 16px;
	margin-top: 32px;
	margin-left: 16px;
	margin: 30px 16px 28px;

	img {
		width: 26px;
	}
`;

export const SearchBarWrapper = styled.div`
	border: 1px solid blue;
	padding: 0.25rem;
	width: 75%;
	border: 1px solid #999999;
	border-radius: 30px;
	display: flex;
	justify-content: space-between;
	padding-right: 6px;
	overflow: hidden;

	input {
		border: none;
		width: 85%;
		padding-left: 14px;
		font-size: 14px;

		&:focus {
			outline: none;
		}
	}
`;

export const NavbarWrapper = styled.nav`
	width: 100%;
	background-color: #ffffff;
	box-shadow: 0px 4px 4px rgba(0, 103, 112, 0.05);
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.64rem 3rem 0.64rem 2rem;

	@media (${devices._sm}) {
		padding-left: 1.5rem;
		padding-right: 1.5rem;
	}

	.searchbar-wrapper {
		border: 1px solid blue;
		padding: 0.25rem;
		width: 75%;
		border: 1px solid #999999;
		border-radius: 30px;
		display: flex;
		justify-content: space-between;
		padding-right: 6px;
		overflow: hidden;

		input {
			border: none;
			width: 85%;
			padding-left: 14px;
			font-size: 14px;

			&:focus {
				outline: none;
			}
		}
	}

	.notifications_wrapper {
		display: flex;
		align-items: center;
		gap: 2rem;
		padding-left: 22px;
	}

	.profile_wrapper {
		position: relative;
		display: flex;
		gap: 0.6rem;
		align-items: center;
		cursor: pointer;
	}

	.dropdown_menu {
		position: absolute;
		top: 60px;
		right: 12px;
		z-index: 99999;
		nav {
			padding: 4px;
			border-radius: 4px;
			background: #fff;
		}
		.nav-link {
			padding: 12px 22px;
			padding-right: 65px;
			border-bottom: 1px solid #e6e6e6;
			gap: 1rem;
			font-weight: 500;
			color: #333;

			.icon {
				width: 18px;
			}

			&:last-child {
				border-bottom: none;
			}
		}
	}
`;
